import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

const DescriptionInput = observer(({ description, setDescriptionCallback }) => (
  <section className="ransom-section ui grid">
    <div className="six wide column">
      <p>
        <strong>Description</strong>
      </p>
      <p className="help-text">Will be included in email receipt sent to customer.</p>
    </div>
    <div className="ten wide column ransom-description">
      <textarea value={description} onChange={event => setDescriptionCallback(event.target.value)} />
    </div>
  </section>
));

DescriptionInput.propTypes = {
  description: PropTypes.string,
  setDescriptionCallback: PropTypes.func.isRequired,
};

export default DescriptionInput;
